<template>
  <div>
  
    <CCard style="margin-top: 20px">
        <CCol xs="12" lg="12" style="margin-top: 20px">
        
            <CTabs variant="pills">
              <CTab title="TowerGame claimed Points" active>
                <hr>
                <Towerclaimed></Towerclaimed>
              </CTab>
              <CTab title="TowerGame unclaimed Points">
                <hr>
              <Towerunclaimed></Towerunclaimed>
              </CTab>
              <CTab title="TowerGame Points Entry">
                <hr>
              <TowerpointEntry></TowerpointEntry>
              </CTab>

              <CTab title="TowerGame Daily Updates">
                <hr>
              <TowerDailyLimit></TowerDailyLimit>
              </CTab>
            </CTabs>
        
      </CCol>
    
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import Towerclaimed from "./towerclaimed.vue"
import Towerunclaimed from "./towerunclaimed.vue"
import TowerpointEntry from "./towerpointEntry.vue"
import TowerDailyLimit from "./towerDailyLimit.vue"
export default {
  components: {
    Towerclaimed,
    Towerunclaimed,
    TowerpointEntry,
    TowerDailyLimit
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
   
     
    };
  },
  watch: {
   
  },
  methods: {
    
    // sendmsg(){}
  },
  created() {

  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>